export default {"src":"/pro/_next/static/media/eigen.72700d50.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};